module.exports = __webpack_public_path__ + "img/4C4C4C_D2D2D2_8F8F8F_ACACAC-256px.46e1211c.png";